<div *ngFor="let ranking of classification">
    <h3>{{ ranking.descricao }}</h3>

    <div class="ranking-classif" *ngFor="let player of ranking.pontos">
        <div class="ranking-player-classif">
            <span>{{ player.posicao }}º</span>
        </div>

        <div class="ranking-info-1">
            <div>
                <span class="d-block player-name"
                    ><strong>{{ player.nome }}</strong></span
                >
            </div>
        </div>

        <div class="ranking-info d-flex">
            <!-- Colunas dinâmicas -->
            <div *ngFor="let header of getSplitedHeader(ranking.cabecalhos); let index = index">
                <!-- prettier-ignore -->
                <span class="d-block"><strong>{{ header }}</strong></span>
                <span>{{ player.colunas[index] }}</span>
            </div>
        </div>
    </div>
</div>

<ng-container *ngIf="!classification">
    <h2 class="not-found">
        Ops!
        <br />
        <span>{{"MESSAGE.RESULT.TRANSACTION-WITHOUT-RETURN" | translate}}</span>
    </h2>
</ng-container>
